import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isQuizImageChoice(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.QUIZ_IMAGE_CHOICE && typeof label === 'string' && Array.isArray(value) && value.every(item => typeof item === 'string');
}
function _formatQuizImageChoice(_ref) {
  let {
    field,
    value
  } = _ref;
  if (value.length === 0) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatQuizImageChoice(submission) {
  if (isQuizImageChoice(submission)) {
    return _formatQuizImageChoice(submission);
  }
  return undefined;
}
//# sourceMappingURL=quiz-image-choice-preview.js.map